import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DyeingColor } from '../../models/production/dyeing/dyeing-color';

import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class LabDipRequestProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip-request';

  public getCustomerColors(customerReference: string): Observable<ApiResponse<DyeingColor[]>> {
    return this.httpClient.get<ApiResponse<DyeingColor[]>>(`${this.baseUrl}/${customerReference}/colors`);
  }

  public getColorsByIds(colorIds: string[]): Observable<ApiResponse<DyeingColor[]>> {
    return this.httpClient.post<ApiResponse<DyeingColor[]>>(`${this.baseUrl}/by-color/batch/ids`, colorIds);
  }
}
